module.exports = "/images/vendor/@sellers-shield-home-protection/ss-ui-kit/src/static/file-icons/word.svg?e86dad8953aa4a4e32f6307865c0adaf";